/* eslint-disable react-hooks/exhaustive-deps */
import { Tooltip, Button, Table, Modal } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";

import { showErrorNotification } from "../../../utils/notification.jsx";

const DetailedSurveyResponses = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  ROOT_URL = "",
  surveyId = "",
  surveyTitle = ""
}) => {
  const [surveyResponsesTableColumns, setSurveyResponsesTableColumns] = useState([]);
  const [surveyResponses, setSurveyResponses] = useState([]);
  const [surveyQuestionsTableColumns, setSurveyQuestionsTableColumns] = useState([]);
  const [surveyQuestions, setSurveyQuestions] = useState([]);

  const fetchSurveyQuestions = () => {
    axios
      .get(`${ROOT_URL}/admin/survey-system/response-analytics/list-survey-questions`, {
        params: {
          surveyId
        }
      })
      .then(({ data }) => {
        const { questions, columns } = data;
        setSurveyQuestions(questions);
        setSurveyQuestionsTableColumns(columns);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchSurveyResponses = () => {
    axios
      .get(`${ROOT_URL}/admin/survey-system/response-analytics/list-survey-responses`, {
        params: {
          surveyId
        }
      })
      .then(({ data }) => {
        const { surveyResponses, columns } = data;
        setSurveyResponses(surveyResponses);
        setSurveyResponsesTableColumns(
          columns.map((column) => ({
            ...column,
            ellipsis: {
              showTitle: false
            },
            render: (text) => (
              <Tooltip placement="topLeft" title={text}>
                {text}
              </Tooltip>
            )
          }))
        );
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  useEffect(() => {
    fetchSurveyQuestions();
    fetchSurveyResponses();
  }, [surveyId]);

  return (
    <Modal
      title="Detailed Survey Responses "
      centered
      width={2000}
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setIsModalOpen(false);
      }}
    >
      <Table
        dataSource={surveyQuestions}
        columns={surveyQuestionsTableColumns}
        pagination
        bordered
        scroll={{ x: "max-content" }}
      />
      <CSVLink
        data={surveyResponses}
        headers={surveyResponsesTableColumns}
        filename={`${surveyTitle} Responses.csv`}
      >
        <Button style={{ margin: "10px 0" }} type="primary">
          Download CSV
        </Button>
      </CSVLink>

      <Table
        dataSource={surveyResponses}
        columns={surveyResponsesTableColumns}
        pagination
        bordered
        scroll={{ x: "max-content" }}
      />
    </Modal>
  );
};

export default DetailedSurveyResponses;
